import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=2b9cf141&scoped=true"
import script from "./detail.vue?vue&type=script&setup=true&lang=js"
export * from "./detail.vue?vue&type=script&setup=true&lang=js"
import style0 from "./detail.vue?vue&type=style&index=0&id=2b9cf141&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b9cf141",
  null
  
)

export default component.exports